export enum ConsumptionSeriesIndex {
  PAST_CONSUMPTION = 0,
  CONSUMPTION = 1,
}
